import { MedosClient } from "../client/MedosClient";
import { ENDPOINTS } from "../constants/endpoints";
function normalizePatient(p) {
    return {
        ...p,
        mrn: p?.mrn ?? p?.mrnNumber ?? null,
        address: p?.address ?? p?.patientAddress ?? null,
    };
}
function lookupParams(lookup) {
    return lookup.channel === "email"
        ? { email: lookup.email }
        : { countryCode: lookup.countryCode, phoneNumber: lookup.phoneNumber };
}
const PatientV2Service = {
    async searchByPhone(lookup) {
        const client = await MedosClient.ensureInitialized();
        const res = await client.get(ENDPOINTS.patients.searchByPhone, {
            params: lookupParams(lookup),
            baseURL: MedosClient.getApiBaseUrlV2(),
        });
        const raw = res.data;
        const payload = raw?.data ?? {};
        const rawPatients = payload.patients ??
            payload.currentWorkspacePatients ??
            payload.associatedPatients ??
            [];
        const packs = payload.activeSessionPacks ??
            payload.activeSessionPackDTOs ??
            payload.activeSessionPackResponses ??
            [];
        const allSessionPacks = payload.allSessionPacks ?? payload.allSessionPackResponses ?? [];
        return {
            success: Boolean(raw?.success),
            message: raw?.message ?? "",
            data: {
                patients: rawPatients.map(normalizePatient),
                activeSessionPacks: packs,
                allSessionPacks,
            },
        };
    },
};
export { PatientV2Service };
